import React from 'react';
import Header from './components/Header';
import Banner from './components/Banner';
import Main from './components/Main';
import Footer from './components/Footer';
import './assets/css/App.css';
import { data } from './api';

function App() {

  return (
    <div className="App">
      {data?.header?.[0]?.nav && 
      data?.header?.[0]?.headerBlocks && 
      data?.banner?.[0] && 
      data.introCopy && 
      data?.faqs?.[0] && 
      data.footerCopy && 
      <>
        <Header
          nav={data.header[0].nav}
          blocks={data.header[0].headerBlocks}
        />
        <Banner data={data.banner[0]} />
        <Main
          intro={data.introCopy}
          faqs={data.faqs[0]} />
        <Footer copy={data.footerCopy} />
      </>}      
    </div>
  );
}

export default App;
